import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const fetchFields = ({settings}: StoreState) => settings.fields;
const byEntityId = (_: StoreState, entity_id: any) => entity_id;
export const getFields = createSelector(fetchFields, ({ids}) => (ids));
export const getFieldsById = createSelector(fetchFields, ({entities}) => (entities));
export const getFieldsByEntityId = createSelector(
    fetchFields,
    ({ byEntityId, entities }) => Object.keys(byEntityId)?.reduce(
        (acc, curr) => acc = {
            ...acc,
            [curr]: byEntityId?.[curr].map(i => entities?.[i])
        },
        {}
    )
);

export const getFieldsByEntityIdAsArray = createSelector(
    [fetchFields, byEntityId],
    ({byEntityId, entities}, entity_id) => byEntityId?.[entity_id]?.map(i => entities?.[i])
);
export const getActiveFieldsByEntityIdAsArray = createSelector(
    [fetchFields, byEntityId],
    ({ byEntityId, entities}, entity_id) => byEntityId?.[entity_id]?.map(i => entities?.[i]).filter(i => i.status !== 0)
)
export const getFieldsByEntityIdAsObject = createSelector(
    [fetchFields, byEntityId],
    ({ byEntityIdByFieldId }, entity_id) => byEntityIdByFieldId?.[entity_id]
);

export const getFieldsAsObject = createSelector(
    [fetchFields],
    ({entities}) => entities
)

export const isFieldsLoading = createSelector(
    [fetchFields],
    ({ _isFetching }) => _isFetching
)

export const getActiveFieldsByEntityId = createSelector(
    fetchFields,
    (_, id) => id,
    ({ byEntityId, entities }, id) => byEntityId?.[id]
        ?.map(i => entities?.[i])
        ?.filter(i => i.status !== 0)
);

export const getPublicFieldsByEntityIdAsArray = createSelector(
    fetchFields,
    (_, id) => id,
    ({ byEntityId, entities }, id) => byEntityId?.[id]
        ?.map(i => entities?.[i])
        ?.filter(i => i.status !== 0)
        ?.filter(i => !!i.is_public)
)